import React from "react";
import { useHistory } from "react-router-dom";
import { alertNotification } from "../../components/TopNotification/alertNotification";
import "./TeamPage.css";
import { TEAM_PAGE_SIZE } from "./helpers";
import { useTeamPage } from "./hooks/useTeamPage";
import TeamHeader from "./components/TeamHeader";
import TeamTable from "./components/TeamTable";
import TeamToolbar from "./components/TeamToolbar";

const TeamPage = () => {
  const history = useHistory();
  const { loading, searchValue, setSearchValue, page, setPage, members, totalMembers, seatSummary } =
    useTeamPage();

  const handleAddMember = () => {
    history.push("/myteams/addmember");
  };

  const handleEditMember = (member) => {
    if (member.memberStatus === "Pending") {
      history.push({
        pathname: "/myteams/activate",
        state: {
          Id: member._id,
          Name: member.FullName ? member.FullName : member.UserName,
          Email: member.EmailAddress,
          JobTitle: member.JobTitle,
          CompanyName: JSON.parse(localStorage.getItem("userProfile"))?.Profiles?.CompanyName,
        },
      });
      return;
    }

    if (member.memberStatus === "Inactive") {
      alertNotification("info", "Use the existing My Teams flow to reactivate inactive members.");
      history.push("/myteams");
      return;
    }

    alertNotification("info", "Editing active team members is not available in the current API flow.");
  };

  return (
    <div className="team-page">
      <TeamHeader />
      <div className="team-page__card">
        <TeamToolbar
          searchValue={searchValue}
          onSearchChange={setSearchValue}
          onAddMember={handleAddMember}
        />
      </div>
      <TeamTable
        loading={loading}
        members={members}
        totalMembers={totalMembers}
        page={page}
        pageSize={TEAM_PAGE_SIZE}
        seatSummary={seatSummary}
        onPageChange={setPage}
        onEditMember={handleEditMember}
      />
    </div>
  );
};

export default TeamPage;
